import { getAccountItems } from "@membership/navigation.account";
import { getStore } from "@shared/utils.locale";
import { useRouter } from "@shared/utils.routing";

interface NavBarItem {
  title: string;
  href: string;
  active: boolean;
}

type NavBarGroup = {
  title: string;
  href?: string;
  items: NavBarItem[];
};

export const useNavBarItems = ({
  isMember
}: {
  isMember: boolean;
}): NavBarGroup[] => {
  const router = useRouter();
  const items = getAccountItems({
    isMember,
    flags: { showMemberBenefits: true }
  });

  return items.map((item) => {
    const buildHref = (url: string) =>
      getStore() === "us" ? `/us${url}` : url;

    const isActive = (url: string): boolean => {
      const path = router.pathname;
      return path === url || path.startsWith(`${url}/`);
    };

    if (item.children?.length) {
      return {
        title: item.title,
        href: item.url !== "#" ? buildHref(item.url) : undefined,
        items: item.children.map((child) => ({
          title: child.title,
          href: buildHref(child.url),
          active: isActive(child.url)
        }))
      };
    }

    return {
      title: item.title,
      href: buildHref(item.url),
      items: [
        {
          title: item.title,
          href: buildHref(item.url),
          active: isActive(item.url)
        }
      ]
    };
  });
};
